import Cookies from 'js-cookie'
import Vue from 'vue'
const TokenKey = 'BPM-Token'
const userTokenKey = 'XXH-SSO-TOKEN'

const UrlParams = new URLSearchParams(location.href.split('?')[1])
let token = UrlParams.get('bpmToken')
let cToken = UrlParams.get('token')
const consoleToken = UrlParams.get('isConsole')
const isYc = UrlParams.get('isYc')
const backUrl = UrlParams.get('backUrl')
const appId = UrlParams.get('appId')
const isInKa = UrlParams.get('isInKa')
if (token) {
  token = token.split('#')[0]
  Vue.prototype.$isInFrame = true
  Vue.prototype.$frameTooken = token
  Vue.prototype.$iframeSource = UrlParams.get('iframeSource')
  setToken(token)
} else {
  if (!Vue.prototype.$isInFrame) {
    Vue.prototype.$isInFrame = false
  }
}
if (isInKa) {
  Vue.prototype.$isInKa = true
  Vue.prototype.$isInFrame = true
}
if (consoleToken) {
  console.log('X-token', Cookies.get('X-Token'))
  const XToken = Cookies.get('X-Token')
  if (XToken && XToken !== ' ' && XToken !== '') {
    setToken(Cookies.get('X-Token'))
  }
  sessionStorage.setItem('isConsole', true)
  if (appId) {
    sessionStorage.setItem('appId', appId)
  }
}
if (cToken) {
  cToken = cToken.split('#')[0]
  setToken(cToken)
  sessionStorage.setItem('isConsole', true)
  if (backUrl) {
    sessionStorage.setItem('backUrl', backUrl)
  }
  if (appId) {
    sessionStorage.setItem('appId', appId)
  }
}

if (isYc) {
  sessionStorage.setItem('isYc', true)
}
function getHostName() {
  return location.hostname.split('.')[1]
}
export function getToken() {
  return Vue.prototype.$frameTooken || Cookies.get(TokenKey)
}
export function getUserTokenKey() {
  return Cookies.get(userTokenKey)
}
export function getlogoutFlag() {
  return Cookies.get('logout')
}
export function removeLogoutFlag() {
  return Cookies.remove('logout')
}
export function setLogoutFlag() {
  return Cookies.set('logout', getUserTokenKey())
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setUserToken(token) {
  const domain = getHostName()
  return Cookies.set(userTokenKey, token, { domain: `${domain}.com` })
}
export function removeToken() {
  console.log('执行了删除cookie')
  if (Vue.prototype.$frameTooken) {
    Vue.prototype.$frameTooken = ''
  }
  const domain = getHostName()
  Cookies.remove('XXH-SSO-TOKEN', { domain: `.${domain}.com` })
  Cookies.remove(TokenKey, { domain: `.${domain}.com` })
  return Cookies.remove(TokenKey)
}
